<template>
  <div class="info-panel" :style="{ height: height ? `${height}px` : 'auto' }">
    <slot name="content" />
  </div>
</template>

<script>
/**
 * Componente utilizado na sidebar para apresentar informações
 */
export default {
  name: 'InfoPanel',
  props: {
    /**
     * Altura do box
     */
    height: {
      type: [Number, String],
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.info-panel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  padding: 18px 14px;
  background-color: $primary;
  text-align: center;

  color: $white;
}
</style>
